function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import Cookies from 'js-cookie';
import { getPortalCodeFromUrl } from "./getPortalCodeFromUrl";
import { getLocalStorage } from "./localStorage";

/**
 * 默认过期时间
 */
var DEFAULT_EXPIRES = 7;

/**
 * 特殊域名截取后3位
 * 普通域名截取后2位
 */
var sepcialDomain = ['com.cn', 'net.cn', 'org.cn'];
var isSpecialDomain = sepcialDomain.some(function (item) {
  return location.origin.includes(item);
});
var sliceNum = (isSpecialDomain ? 3 : 2) * -1;

/**
 * 不保存fromurl的路由
 */
var noSavePath = ['user', 'seller', 'egzlogin', 'sclogin', 'select', '404', '500', ''];
/**
 * 需要使用portalCode前缀的key
 */
var NEED_PORTALCODE_KEYS = ['FROM_URL'];

/**
 * pc的cookie的枚举
 */
export var KEYS_PC = /*#__PURE__*/function (KEYS_PC) {
  KEYS_PC["SID"] = "sid";
  KEYS_PC["ALIAS"] = "alias";
  KEYS_PC["SELECT_ORG_CODE"] = "selectOrgCode";
  KEYS_PC["SELECT_IDENTITY_CODE"] = "selectIdentityCode";
  KEYS_PC["DEFAULT_IDENTITY_CODE"] = "defaultIdentityCode";
  KEYS_PC["SELECT_ROLE_NAME"] = "selectRoleName";
  KEYS_PC["SELECT_USER_TYPE"] = "selectUserType";
  KEYS_PC["SOURCE_TYPE"] = "sourceType";
  KEYS_PC["QUICK_LOGIN_TYPE"] = "quick_login_type";
  KEYS_PC["URL_LOGIN_TYPE"] = "urlLoginType";
  KEYS_PC["TOKEN"] = "token";
  KEYS_PC["RANDOM_CODE"] = "randomCode";
  KEYS_PC["USER_CODE"] = "userCode";
  KEYS_PC["ORG_NAME"] = "orgName";
  KEYS_PC["ORG_ENROLL"] = "orgEnroll";
  KEYS_PC["FROM_URL"] = "fromUrl";
  KEYS_PC["FROM_TERMINAL_URL"] = "fromTerminalUrl";
  KEYS_PC["FROM_URL_USER_TYPE"] = "fromUrlUserType";
  KEYS_PC["PERSON_MERCHANT_ROUTE"] = "personMerchantRoute";
  return KEYS_PC;
}({});
/**
 * h5的cookie的枚举
 */
export var KEYS_H5 = /*#__PURE__*/function (KEYS_H5) {
  KEYS_H5["ALIAS"] = "h5Alias";
  KEYS_H5["FROM_URL"] = "h5FromUrl";
  KEYS_H5["USER_TYPE"] = "h5SelectUserType";
  KEYS_H5["TOKEN"] = "h5Token";
  KEYS_H5["RANDOM_CODE"] = "randomCode";
  KEYS_H5["USER_CODE"] = "h5UserCode";
  KEYS_H5["SELECT_ORG_CODE"] = "h5SelectOrgCode";
  KEYS_H5["USER_DEFAULT_IDENTITY"] = "h5UserDefaultIdentity";
  KEYS_H5["SELECT_IDENTITY_MAP"] = "h5SelectIdentityMap";
  KEYS_H5["PREVIEW_URL"] = "h5PreviewUrl";
  KEYS_H5["ORG_NAME"] = "h5OrgName";
  KEYS_H5["SELECT_ROLE_NAME"] = "selectRoleName";
  KEYS_H5["SELECT_USER_TYPE"] = "selectUserType";
  KEYS_H5["FROM_TERMINAL_URL"] = "fromTerminalUrl";
  KEYS_H5["FROM_URL_USER_TYPE"] = "h5FromUrlUserType";
  KEYS_H5["PERSON_MERCHANT_ROUTE"] = "h5PersonMerchantRoute";
  return KEYS_H5;
}({});

/** 需要使用sid区分的键 */
var NEED_SID_KEYS_PC = ['ALIAS', 'TOKEN', 'RANDOM_CODE', 'USER_CODE', 'SELECT_ORG_CODE', 'SELECT_USER_TYPE', 'SELECT_ROLE_NAME', 'FROM_URL', 'SOURCE_TYPE', 'SELECT_IDENTITY_CODE', 'ORG_ENROLL', 'FROM_TERMINAL_URL', 'FROM_URL_USER_TYPE', 'URL_LOGIN_TYPE'];
/** 需要使用sid区分的键 */
var NEED_SID_KEYS_H5 = ['ALIAS', 'TOKEN', 'RANDOM_CODE', 'USER_CODE', 'USER_TYPE', 'FROM_URL', 'SELECT_ORG_CODE', 'USER_DEFAULT_IDENTITY', 'SELECT_IDENTITY_MAP', 'SELECT_USER_TYPE', 'SELECT_ROLE_NAME', 'FROM_TERMINAL_URL', 'FROM_URL_USER_TYPE'];

/** 获取cookie的domain */
var getCookieDomain = function getCookieDomain() {
  var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  var domain = '';
  if (!window.location.hostname.match(ipReg)) {
    var tempDomain = window.location.hostname.split('.') || [];
    if (tempDomain.length > 2) {
      var domainArr = tempDomain.slice(sliceNum);
      domain = '.' + domainArr.join('.');
    }
  }
  return domain;
};

/**
 * 获取 cookie
 * @param key
 * @returns
 */
export var getCookie = function getCookie(key) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pc';
  var res = '';
  var sid = getLocalStorage('SID') || '';
  var KEYS = type === 'pc' ? KEYS_PC : KEYS_H5;
  var NEED_SID_KEYS = type === 'pc' ? NEED_SID_KEYS_PC : NEED_SID_KEYS_H5;
  var portalCode = getPortalCodeFromUrl();
  var getRes = function getRes(prefix) {
    if (NEED_SID_KEYS.includes(key)) {
      //@ts-ignore
      res = Cookies.get("".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(KEYS[key]).concat(sid));
    } else {
      //@ts-ignore
      res = Cookies.get("".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(KEYS[key]));
    }
  };
  if (portalCode) {
    if (NEED_PORTALCODE_KEYS.includes(key)) {
      getRes(portalCode);
    } else {
      getRes();
    }
    if (key === 'SELECT_USER_TYPE') {
      res = 'user';
    }
    if (key === 'SELECT_IDENTITY_CODE') {
      res = '5';
    }
    if (key === 'USER_DEFAULT_IDENTITY') {
      res = '5';
    }
  } else {
    getRes();
  }
  try {
    return JSON.parse(res);
  } catch (e) {
    return res;
  }
};

/**
 * 写入 cookie
 * @param key
 * @param data
 * @param expires
 */
export var setCookie = function setCookie(key, data) {
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_EXPIRES;
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'pc';
  if (!window) return;
  var KEYS = type === 'pc' ? KEYS_PC : KEYS_H5;
  var NEED_SID_KEYS = type === 'pc' ? NEED_SID_KEYS_PC : NEED_SID_KEYS_H5;
  var portalCode = getPortalCodeFromUrl();
  var sid = getLocalStorage('SID') || '';
  var domain = getCookieDomain();
  var setRes = function setRes(prefix) {
    if (NEED_SID_KEYS.includes(key)) {
      Cookies.set( //@ts-ignore
      "".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(KEYS[key]).concat(sid), _typeof(data) === 'object' ? JSON.stringify(data) : data, {
        expires: expires,
        domain: domain
      });
    } else {
      Cookies.set( //@ts-ignore
      "".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(KEYS[key]), _typeof(data) === 'object' ? JSON.stringify(data) : data, {
        expires: expires,
        domain: domain
      });
    }
  };
  if (key === 'FROM_URL') {
    var _window, _pathname$replace$spl;
    var _window$location = (_window = window) === null || _window === void 0 ? void 0 : _window.location,
      pathname = _window$location.pathname;
    var firstPath = (_pathname$replace$spl = pathname.replace('/', '').split('/')) === null || _pathname$replace$spl === void 0 ? void 0 : _pathname$replace$spl[0];
    if (noSavePath.includes(firstPath)) return;
    expires = 0.02;
  }
  if (portalCode) {
    // if (key === 'SELECT_IDENTITY_CODE') {
    //   data = '5';
    // }

    // if (key === 'USER_DEFAULT_IDENTITY') {
    //   data = '5';
    // }
    if (NEED_PORTALCODE_KEYS.includes(key)) {
      setRes(portalCode);
    } else {
      setRes();
    }
  } else {
    setRes();
  }
};

/**
 * 删除
 * @param key
 */
export var delCookie = function delCookie(key) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pc';
  if (!window) return;
  var KEYS = type === 'pc' ? KEYS_PC : KEYS_H5;
  var NEED_SID_KEYS = type === 'pc' ? NEED_SID_KEYS_PC : NEED_SID_KEYS_H5;
  var portalCode = getPortalCodeFromUrl();
  var sid = getLocalStorage('SID') || '';
  var domain = getCookieDomain();
  var delRes = function delRes(prefix) {
    if (NEED_SID_KEYS.includes(key)) {
      //@ts-ignore
      Cookies.remove("".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(KEYS[key]).concat(sid), {
        domain: domain
      });
    } else {
      //@ts-ignore
      Cookies.remove("".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(KEYS[key]), {
        domain: domain
      });
    }
  };
  if (portalCode) {
    if (NEED_PORTALCODE_KEYS.includes(key)) {
      delRes(portalCode);
    } else {
      delRes();
    }
  } else {
    delRes();
  }
};

/**
 * 普通删除
 * @param key
 */
export var delNormalCookie = function delNormalCookie(key) {
  if (!window) return;
  var domain = getCookieDomain();
  Cookies.remove(key, {
    domain: domain
  });
};

/**
 * 删除所有cookie
 */
export var clearCookie = function clearCookie() {
  if (!window) return;
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g) || [];
  if (Object.prototype.toString.call(keys) === '[object Array]') {
    keys.map(function (key) {
      Cookies.remove(key);
    });
  }
};